import { type PublicEventContentObject, createPublicEventContentObject } from 'models';
import { useQuery } from 'query';
import type { PublicEventContentObjectDataObject } from 'models/service';

import { getEvent } from '../services';

import { getEventDetailQueryKey } from './keys';

export const useEventPublicQuery = (
  { eventId, invitationToken }: { eventId: string; invitationToken?: string },
  options?: { throwOnError?: boolean },
) =>
  useQuery<PublicEventContentObject>({
    async queryFn() {
      /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
      const { data: eventContenObject } = await getEvent<PublicEventContentObjectDataObject>(eventId, {
        invitation_token: invitationToken,
      });
      /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */
      return createPublicEventContentObject(eventContenObject);
    },
    queryKey: getEventDetailQueryKey({ id: eventId, invitationToken, view: 'public' }),
    throwOnError: true,
    ...options,
  });
